"use client";

import Link from "next/link";
import { event as gtagEvent } from "@/lib/gtag";
import { getQuestionById } from "@/lib/questions";

interface InlineCtaProps {
  questionId: number;
  slug: string;
}

export function InlineCta({ questionId, slug }: InlineCtaProps) {
  const question = getQuestionById(questionId);
  const label = question.text.replace(/。$/, "");

  const handleClick = () => {
    gtagEvent("guide_inline_cta_click", {
      guide_slug: slug,
      question_id: questionId,
      cta_position: "inline",
    });
  };

  return (
    <div className="my-8 p-4 rounded-lg bg-accent/5 border border-accent/20 flex items-center gap-4">
      <div className="flex-1">
        <p className="text-sm font-semibold text-on-surface">
          「{label}」をAI面接官で練習してみませんか？
        </p>
        <p className="text-xs text-on-surface-variant mt-0.5">
          音声で回答するだけで、5つの軸でスコアリングします
        </p>
      </div>
      <Link
        href={`/practice?questionId=${questionId}&utm_source=guide&utm_medium=inline_cta&utm_content=${slug}`}
        onClick={handleClick}
        className="shrink-0 text-xs font-semibold text-white bg-accent hover:bg-accent-hover px-4 py-2 rounded-md transition-colors shadow-[0_2px_8px_rgba(246,122,80,0.15)]"
      >
        練習する →
      </Link>
    </div>
  );
}
